export const useSearchNavigate = () => {
    const searchUrl = useSearchUrl();
    const route = useRoute();
    const getBaseRouteName = useRouteBaseName(); // strips language code from route name

    return function searchNavigate(query: string, manufacturerPath?: string) {
        const routeBaseName = getBaseRouteName(route);
        const isSearch = routeBaseName == "search-path";

        /* Navigate to search results with a full page refresh ("external") because search may do a redirect, and a 302
        is better for browser history in that case. On the search page itself, however, a client-side redirect is best
        because the search page is heavy and has ads.
         */
        return navigateTo(searchUrl(query, manufacturerPath), { external: !isSearch });
    };
};
